"use client";

import { cn } from "@/lib/utils";

export default function Title(props: {
  // 默认h2
  heading?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  title: string;
  underline?: boolean;
  className?: string;
}) {
  const { heading = "h2", underline = true } = props;
  const HeadingTag = heading;
  return (
    <HeadingTag
      className={cn(
        "flex flex-col items-center text-center text-xl font-semibold leading-tight md:text-[44px] md:leading-snug",
        props.className
      )}>
      {props.title}
      {underline && (
        <hr className="mt-2 h-1 w-6 border-none bg-primary md:mt-3 md:h-1.5 md:w-16" />
      )}
    </HeadingTag>
  );
}
